"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveRegionalUrl = exports.ENTITY_ID_PLACEHOLDER = exports.REGION_URL_PLACEHOLDER = void 0;
const regionUtils_1 = require("./regionUtils");
exports.REGION_URL_PLACEHOLDER = `\${Region}`;
exports.ENTITY_ID_PLACEHOLDER = `\${EntityId}`;
function resolveRegionalUrl(applicationUrl, selectedRegion, entityKeys) {
    let domain;
    // Check if we're in Beta envs
    if (window.location.hostname.includes('.integ.')) {
        domain = regionUtils_1.regionToUrlBetaDomainMapping.get(selectedRegion);
    }
    else if (window.location.hostname.includes('-preprod')) {
        domain = regionUtils_1.regionToUrlGammaDomainMapping.get(selectedRegion);
    }
    else {
        domain = regionUtils_1.regionToUrlProdDomainMapping.get(selectedRegion);
    }
    const switchToEntityId = (0, regionUtils_1.getEntityIdFromRegionalEntityKey)(entityKeys, selectedRegion);
    if (switchToEntityId) {
        return applicationUrl
            .replace(exports.REGION_URL_PLACEHOLDER, domain)
            .replace(exports.ENTITY_ID_PLACEHOLDER, switchToEntityId);
    }
}
exports.resolveRegionalUrl = resolveRegionalUrl;
//# sourceMappingURL=resolveRegionalUrl.js.map